import { as400DivisionCode } from '@erp/rpc';

export function divisionTokensFromValue(value: string): string[] {
  return value
    .split(/[/,;]+/)
    .map((part) => as400DivisionCode(part))
    .filter((part) => part.length > 0);
}

export function uniqueDivisionSegment(values: readonly string[]): string {
  return [...new Set(values.flatMap(divisionTokensFromValue))].sort().join('-');
}

export function suggestedDownloadFileName(args: {
  reportType: string;
  division: string;
  date: string;
}): string {
  const parts = [args.reportType, args.division, args.date].filter(
    (part) => part.length > 0,
  );
  return `${parts.join('_')}.csv`;
}

export function sanitizeChosenDownloadFileName(fileName: string): string {
  const leaf = fileName.trim().split(/[/\\]/).pop() ?? '';
  const cleaned = leaf
    .replace(/[\\/:*?"<>|]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  if (cleaned.length === 0) return '';
  const stem = cleaned.replace(/\.csv$/i, '').trim();
  if (stem.length === 0) return '';
  return `${stem}.csv`;
}
